import { render, staticRenderFns } from "./PracticeOverview.vue?vue&type=template&id=bae54df4&scoped=true"
import script from "./PracticeOverview.vue?vue&type=script&lang=js"
export * from "./PracticeOverview.vue?vue&type=script&lang=js"
import style0 from "./PracticeOverview.vue?vue&type=style&index=0&id=bae54df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae54df4",
  null
  
)

export default component.exports